// extracted by mini-css-extract-plugin
export default {"card":"Ima-z","isSwatchGrouping":"Jma-z"};